import type { ComponentType } from 'react';
import { Input, SegmentedControl } from '@wapharma/design-system';
import { IconAlignLeft, IconList, IconNumbers } from '@tabler/icons-react';
import type { ProductDetailKindCode } from '@wapharma/domain';

/** Step 1 — libellé only; code derived from name on submit. */
export function ProductDetailTypeCreateFields({
  name,
  onNameChange,
}: {
  name: string;
  onNameChange: (v: string) => void;
}) {
  return (
    <Input
      label="Nom"
      placeholder="Ex. Ingrédients"
      value={name}
      onChange={(e) => onNameChange(e.target.value)}
      autoFocus
    />
  );
}

export type ProductDetailKindIcon = ComponentType<{
  size?: number;
  stroke?: number;
  'aria-hidden'?: boolean;
}>;

const KIND_CHOICES: Array<{
  value: ProductDetailKindCode;
  label: string;
  Icon: ProductDetailKindIcon;
}> = [
  { value: 'TEXT', label: 'Texte', Icon: IconAlignLeft },
  { value: 'LIST', label: 'Liste', Icon: IconList },
  { value: 'NUMBER', label: 'Nombre', Icon: IconNumbers },
];

/** Icon for fiche detail value shape (TEXT / LIST / NUMBER). */
export function productDetailKindIcon(kind: ProductDetailKindCode): ProductDetailKindIcon {
  return KIND_CHOICES.find((c) => c.value === kind)?.Icon ?? IconAlignLeft;
}

export function productDetailKindShortLabel(kind: ProductDetailKindCode): string {
  return KIND_CHOICES.find((c) => c.value === kind)?.label ?? 'Texte';
}

/** Step 2 — value shape. */
export function ProductDetailTypeKindFields({
  kind,
  onKindChange,
}: {
  kind: ProductDetailKindCode;
  onKindChange: (v: ProductDetailKindCode) => void;
}) {
  return (
    <SegmentedControl
      aria-label="Type de saisie"
      value={kind}
      options={KIND_CHOICES.map(({ value, label }) => ({ value, label }))}
      onChange={onKindChange}
    />
  );
}
